<template>
    <div class="users-style">
        
        
        

                <div class="clearfix">
                    <div class="col-md-6 float-left">
                    
                        <b-form-group id="name-group" label="Name" label-for="name">
                            {{fdata.name}}
                        </b-form-group>

                        <b-form-group id="tagline-group" label="Tagline" label-for="tagline">
                            {{fdata.tagline}}
                        </b-form-group>

                        <b-form-group id="email-group" label="Email" label-for="email">
                            {{fdata.email}}
                        </b-form-group>

                        <b-form-group id="phone-group" label="Phone" label-for="phone">
                            {{fdata.phone}}
                        </b-form-group>

                        <b-form-group id="address-group" label="Address" label-for="address">
                            {{fdata.address}}
                        </b-form-group>

                        <b-form-group id="zip-group" label="Zip" label-for="zip">
                            {{fdata.zip}}
                        </b-form-group>

                        <b-form-group id="city-group" label="City" label-for="city">
                            {{fdata.city}}
                        </b-form-group>

                    

                    </div>

                    <div class="col-md-6 float-right ">

                        <b-form-group id="code-group" label="Code" label-for="code">
                            {{fdata.code}}
                        </b-form-group>

                        <b-form-group id="tin-group" label="Tin" label-for="tin">
                            {{fdata.tin}}
                        </b-form-group>

                        <b-form-group id="bin-group" label="Bin" label-for="bin">
                            {{fdata.bin}}
                        </b-form-group>

                        <b-form-group id="tax_zone-group" label="Tax Zone" label-for="tax_zone">
                            {{fdata.tax_zone}}
                        </b-form-group>

                        <b-form-group id="tax_circle-group" label="Tax Circle" label-for="tax_circle">
                            {{fdata.tax_circle}}
                        </b-form-group>


                        <b-form-group id="logo-group" label="Logo" label-for="logo">
                            
                            <div class="mt-3" v-if="fdata.logo">
                                <img v-bind:src="$api_url+'/images/company/' + fdata.logo"  class="img-fluid img-thumbnail" width="100" />
                            </div>
                            
                        </b-form-group>

                    </div>
                </div>



    </div>
</template>


<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        props: [],
        data(){            
            
            return {
                
                
                fdata:[],
                
                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],
                
                
            }
        },
        methods:{
            getCompanyData: function()
            {
                axios.get(this.$api_url+'/company/detailsinfo' , {
                    params: {
                        //id: 1
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.file = null;
                }.bind(this));
            },

        },
        created: function(){
            this.getCompanyData();
        }
    }
</script>